import { APICore } from 'helpers/api/apiCore'
import {
  RequestInserirSolicitacaoDto
  // RequestValidacaoTokenIn100Dto
} from 'models/cadastros/validacao/types'
import { ConvenioDado } from 'models/types'
import { ArquivoCrefaz, Referencia } from 'store/modules/simulacao/types'
import { removeMaskCPF } from 'util/masks'

const api = new APICore()

export function getClienteMatriculaCpf() {
  return api.get(`Generic/informacoes-cliente-matricula`, null)
}

// export function validaStatusIN100(cpf: string, matricula: string) {
//   const cpfFormatted = removeMaskCPF(cpf)
//   return api.create(`In100/valida-status-in100`, {
//     cpf: cpfFormatted,
//     matricula
//   })
// }

export function getPropostasCrm(cpf: string, numeroMatricula: string) {
  const cpfFormatted = removeMaskCPF(cpf)
  return api.get(`Simulacao/simulacao`, {
    cpf: cpfFormatted,
    numeroMatricula
  })
}

export function getPropostasCrefaz(cpf: string) {
  const cpfFormated = removeMaskCPF(cpf)
  return api.get(`Simulacao/emprestimo-crefaz`, {
    cpf: cpfFormated
  })
}

export function getTiposArquivoCrefaz() {
  return api.get(`Generic/tipo-arquivos-crefaz`, null)
}

export function salvarAnexo(params: {
  cpf: string
  tipoArquivoCrefazId: string
  arquivo: File | null
}) {
  return api.createWithFile(
    `Crefaz/upload-arquivo?cpf=${params.cpf}&tipoArquivoCrefazId=${
      params.tipoArquivoCrefazId
    }&envioCrefaz=${false}`,
    { arquivo: params.arquivo }
  )
}

export function downloadAnexo(params: { cpf: string; nomeArquivo: string }) {
  return api.update(
    `Crefaz/download-arquivo?cpf=${params.cpf}&nomeArquivo=${params.nomeArquivo}`,
    null
  )
}

export function deletarAnexo(params: { cpf: string; nomeArquivo: string }) {
  return api.delete(
    `Crefaz/arquivo?cpf=${params.cpf}&nomeArquivo=${params.nomeArquivo}`
  )
}

export function getAnexos(params: {
  cpf: string
  pagina: number
  registros: number
}) {
  const cpfFormated = removeMaskCPF(params.cpf)
  return api.get(`Crefaz/arquivos`, {
    ...params,
    pagina: params.pagina + 1,
    cpf: cpfFormated
  })
}

export function solicitarSimulacaoFgts() {
  return api.create(`fgts/solicitar-simulacao`, {
    valorSolicitado: 0,
    quantidadeParcela: 10
  })
}

export function getParcelaFgts() {
  return api.get(`fgts/parcela`, null)
}

export function recalculoProposta(
  cpf: string,
  servico: number,
  parcelas: number,
  valorTotalFinanciado: number | null,
  valorParcela: number | null,
  tabela: number,
  numeroMatricula: string,
  banco: number
) {
  const cpfFormatted = removeMaskCPF(cpf)
  return api.getWithoutUndefined(`Simulacao/recalculo`, {
    cpf: cpfFormatted,
    quantidadeParcelas: parcelas,
    codigoProduto: tabela,
    servico,
    valorTotalFinanciado,
    valorParcela,
    numeroMatricula,
    banco
  })
}

export function recalculoCrefaz(
  cpf: string,
  propostaId: number,
  valor: number,
  convenioDados: ConvenioDado[]
) {
  const cpfFormated = removeMaskCPF(cpf)
  return api.update(`Simulacao/selecao-oferta-emprestimo-crefaz`, {
    cpf: cpfFormated,
    propostaId,
    valor,
    convenioDados
  })
}

export function recalculoPropostaFgts(valor: number, parcelas: number) {
  return api.create(`fgts/solicitar-simulacao`, {
    valorSolicitado: valor,
    quantidadeParcela: parcelas
  })
}

export function validacaoContratacao(
  cpf: string,
  matriculas: string[],
  bancos: number[]
) {
  return api.create(`Contratacao/validacao-contratacao`, {
    cpf,
    matriculas,
    bancos
  })
}

export function getResumoContratacao(
  cpf: string,
  matriculas: string[],
  bancos: number[]
) {
  return api.create(`Contratacao/resumo-contratacao`, {
    matriculas,
    cpf,
    bancos
  })
}

interface FinalizacaoEmprestimoBmg {
  cpf: string
  numeroMatricula: string
  quantidadeParcelas: number
  valorParcela: number
  servico: number
  numeroProduto: number
  bancoSimulacaoEnum: number
  codigoFormaEnvioTermo: string
  valorLiberado: number
}

export async function finalizacaoEmprestimoBmg({
  cpf,
  ...params
}: FinalizacaoEmprestimoBmg) {
  const cpfFormatted = removeMaskCPF(cpf)
  return api.create(`Contratacao/emprestimo_bmg`, {
    cpf: cpfFormatted,
    ...params
  })
}

interface FinalizacaoEmprestimoItau {
  codigoSimulacao: number
  cpf: string
  numeroMatricula: string
  quantidadeParcelas: number
  valorParcela: number
  servico: number
  bancoSimulacaoEnum: number
  valorLiberado: number
}

export async function finalizacaoEmprestimoItau({
  cpf,
  ...params
}: FinalizacaoEmprestimoItau) {
  const cpfFormatted = removeMaskCPF(cpf)
  return api.create(`Contratacao/emprestimo_itau`, {
    cpf: cpfFormatted,
    ...params
  })
}

interface FinalizacaoCartaoCreditoBmg {
  cpf: string
  numeroMatricula: string
  valorSaque: number
  servico: number
  flagAberturaConta: boolean
  flagSaqueAutorizado: boolean
  bancoSimulacaoEnum: number
}

export async function finalizacaoCartaoCreditoBmg({
  cpf,
  ...params
}: FinalizacaoCartaoCreditoBmg) {
  const cpfFormatted = removeMaskCPF(cpf)
  return api.create(`Contratacao/cartao-credito-bmg`, {
    cpf: cpfFormatted,
    ...params
  })
}

interface FinalizacaoCartaoBeneficioBmg {
  cpf: string
  numeroMatricula: string
  flagSaqueAutorizado: boolean
  flagSaqueParcelado: boolean
  quantidadeParcelas: number
  valorParcela: number
  valorSaque: number
  servico: number
  flagAberturaConta: boolean
  bancoSimulacaoEnum: number
}

export async function finalizacaoCartaoBeneficioBmg({
  cpf,
  ...params
}: FinalizacaoCartaoBeneficioBmg) {
  const cpfFormatted = removeMaskCPF(cpf)
  return api.create(`Contratacao/cartao-beneficio-bmg`, {
    cpf: cpfFormatted,
    ...params
  })
}

interface FinalizacaoSaqueCartaoBmg {
  cpf: string
  numeroMatricula: string
  numeroContaInterna: number
  quantidadeParcelas: number
  valorParcela: number
  valorSaque: number
  flagSaqueAutorizado: boolean
  flagAberturaConta: boolean
  servico: number
  bancoSimulacaoEnum: number
}

export async function finalizacaoSaqueCartaoBmg({
  cpf,
  ...params
}: FinalizacaoSaqueCartaoBmg) {
  const cpfFormatted = removeMaskCPF(cpf)
  return api.create(`Contratacao/saque-cartao-bmg`, {
    cpf: cpfFormatted,
    ...params
  })
}

export async function finalizacaoContratacaoFgts() {
  return api.create(`fgts/solicitar-proposta`, null)
}

interface FinalizacaoSeguroSindinapiBmg {
  cpf: string
  numeroMatricula: string
  servico: number
  bancoSimulacaoEnum: number
}

export async function finalizacaoContratacaoSeguroSindinapiBmg({
  cpf,
  ...params
}: FinalizacaoSeguroSindinapiBmg) {
  const cpfFormatted = removeMaskCPF(cpf)
  return api.create(`Contratacao/seguro-sindnapi-bmg`, {
    cpf: cpfFormatted,
    ...params
  })
}

export interface FinalizacaoEmprestimoCrefaz {
  cpf: string
  servico: number
  propostaId: number
  tabelaJurosId: number
  valorSolicitado: number
  valorParcela: number
  quantidadeParcelas: number
  vencimento: string
  produtoId: number
  convenioId: number
  rendaPresumida: number
}

export async function finalizacaoContratacaoEmprestimoCrefaz({
  cpf,
  ...params
}: FinalizacaoEmprestimoCrefaz) {
  const cpfFormatted = removeMaskCPF(cpf)
  return api.create(`Contratacao/emprestimo-crefaz`, {
    cpf: cpfFormatted,
    ...params
  })
}

export function getPerfis() {
  return api.get(`Generic/perfis`, null)
}

export function getTiposConta() {
  return api.get(`Generic/tipos-conta`, null)
}

export function getBancos() {
  return api.get(`Generic/bancos-dados-bancarios`, null)
}

export function getConvenios() {
  return api.get(`Generic/convenios`, null)
}

export function inserirSolicitacaoIn100(params: RequestInserirSolicitacaoDto) {
  return api.create(`In100/inserir-solicitacao`, params)
}

// export function validarTokenIn100(params: RequestValidacaoTokenIn100Dto) {
//   return api.create(`In100/validar-token`, params)
// }

export function getTiposDocumentoCrefaz() {
  return api.get(`Crefaz/tipo-arquivos-crefaz`, null)
}

interface RequestUploadArquivosCrefazDto {
  cpf: string
  tipoArquivoCrefazId: string
  arquivo: ArquivoCrefaz
}
export function uploadArquivosCrefaz({
  arquivo,
  ...params
}: RequestUploadArquivosCrefazDto) {
  const formData = new FormData()
  if (arquivo.uploadedFile) {
    formData.append('arquivo', arquivo.uploadedFile)
  }
  return api.createWithFilesCrefaz(
    `Crefaz/upload-arquivos?cpf=${params.cpf}&tipoArquivoCrefazId=${
      params.tipoArquivoCrefazId
    }&envioCrefaz=${false}`,
    formData
  )
}

export function getGrausReferencia() {
  return api.get(`Crefaz/graus-referencia`, null)
}

export function getReferencias() {
  return api.get(`Crefaz/referencias`, null)
}

export function salvarReferencias(referencias: Referencia[]) {
  return api.create(`Crefaz/referencias`, referencias)
}
